import { jsx, jsxs } from "react/jsx-runtime";
import "react";
import { f as PropTypes } from "./OfferCta-OU6Yjw7w.js";
import { BREAKPOINT_DIMENSIONS, DesignSystemProvider } from "@quickenloans-ui-suite/design-system";
import { E as ENVIRONMENTS } from "./useCustomScrollTrigger-DD3As7oF.js";
import { F as FOCUS_OUTLINE_CLASS, M as MKT_CONTAINER_ID } from "./index-BIblv54e.js";
import { a as useIsTestMode, b as useMarketingClickId, u as useFetchOffers } from "./useMarketingClickId-N3aoPnYp.js";
import { Box } from "@mui/material";
import "./index-C9TrZnbr.js";
import { h as SkeletonMarketplace, O as OfferCard } from "./OfferCard-C6oPasBm.js";
import "./mockSkeletons-Dzu6jNn4.js";
import { styled } from "@mui/system";
const components = {
  components: {
    MuiCssBaseline: {
      styleOverrides: (theme) => ({
        [`&.${FOCUS_OUTLINE_CLASS}`]: {
          "&:focus-visible": {
            outline: "auto 1px black"
          }
        }
      })
    }
  }
};
const MarketPlaceContainer = styled(Box)(({ theme }) => ({
  [`#${MKT_CONTAINER_ID}&`]: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2, 0),
    gap: "24px",
    width: "100%"
  }
}));
const OfferContainer = styled(Box)(({ theme }) => ({
  [`#${MKT_CONTAINER_ID} &`]: {
    width: "100%",
    maxWidth: "500px",
    [theme.breakpoints.up(BREAKPOINT_DIMENSIONS.large)]: {
      maxWidth: "none"
    }
  }
}));
const Offers = ({
  isTestMode,
  marketingClickId,
  offers,
  offersError,
  offersSuccess,
  sourceId
}) => {
  if (!offersSuccess || offersError) {
    if (offersError) {
      console.error({ offersError });
    }
    return /* @__PURE__ */ jsx(SkeletonMarketplace, {});
  }
  return offers.map((offer, index2) => /* @__PURE__ */ jsxs(
    OfferContainer,
    {
      className: "marketplace-card",
      itemProp: "itemListElement",
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      children: [
        /* @__PURE__ */ jsx(
          OfferCard,
          {
            index: index2,
            isTestMode,
            marketingClickId: marketingClickId ?? "",
            offer,
            sourceId
          }
        ),
        /* @__PURE__ */ jsx("meta", { itemProp: "position", content: index2 + 1 })
      ]
    },
    index2
  ));
};
const Marketplace = ({
  environment = ENVIRONMENTS.PRODUCTION,
  product,
  sourceId,
  sx = {}
}) => {
  const isTestMode = useIsTestMode();
  const { marketingClickId } = useMarketingClickId();
  const { offers, offersError, offersSuccess } = useFetchOffers({ environment });
  return /* @__PURE__ */ jsx(
    DesignSystemProvider,
    {
      appName: "marketplace",
      theme: { ...components },
      shouldMergeWithBaseTheme: true,
      importCss: true,
      children: /* @__PURE__ */ jsxs(
        MarketPlaceContainer,
        {
          "data-testid": "marketplace-container",
          itemScope: true,
          itemType: "https://schema.org/ItemList",
          id: MKT_CONTAINER_ID,
          sx,
          children: [
            /* @__PURE__ */ jsx("meta", { itemProp: "numberOfItems", content: offers.length }),
            /* @__PURE__ */ jsx("meta", { itemProp: "itemListOrder", content: "https://schema.org/ItemListOrderAscending" }),
            /* @__PURE__ */ jsx(
              Offers,
              {
                isTestMode,
                marketingClickId,
                offers,
                offersError,
                offersSuccess,
                sourceId
              }
            )
          ]
        }
      )
    }
  );
};
Marketplace.propTypes = {
  environment: PropTypes.string,
  sourceId: PropTypes.string,
  product: PropTypes.string,
  sx: PropTypes.object
};
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Marketplace
}, Symbol.toStringTag, { value: "Module" }));
export {
  Marketplace as M,
  index as i
};
//# sourceMappingURL=index-DN__CBXE.js.map
